import { sendGTMEvent } from "@next/third-parties/google";
import { useEffect } from "react";

export const sendEvent = (event: string, options: object = {}) => {
	sendGTMEvent({ event, ...options });
};

export const sendPageViewEvent = (location: string) => {
	sendEvent("page_view", {
		page_location: location,
	});
};

export const sendSignInEvent = (email: string) => {
	sendEvent("sign_in", {
		user_email: email,
	});
};

export const sendSignUpEvent = ({
	name,
	companyName,
	email,
}: {
	name: string;
	companyName: string;
	email: string;
}) => {
	sendEvent("sign_up", {
		user_name: name,
		user_company_name: companyName,
		user_email: email,
	});
};

export function useSendCurrentPageViewEvent() {
	useEffect(() => {
		sendPageViewEvent(window.location.pathname);
	}, []);
}
